import React, { useState } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import "./PromotionCards.css";
import Evolving from "./evolving.jpg";
import Achievement from "./achievement.jpg";
import Comfort from "./comfort.jpg";
import Relax from "./relax.jpg";

PromotionCard.propTypes = {
  title: PropTypes.string,
  advantages: PropTypes.arrayOf(PropTypes.string),
  image: PropTypes.string,
};

const mock = [
  {
    title: "Быстрое развитие",
    needToLineBreak: false,
    advantages: [
      "прозрачная карьерная лестница, возможность реализовать себя в смежных областях",
      "возможность обучения у внешних бизнес-тренеров",
      "регулярное повышение квалификации у лучших специалистов",
      "доступ к корпоративной библиотеке",
      "программа наставничества – бесценный опыт коллег",
    ],
    image: Evolving,
  },
  {
    title: "Яркие достижения",
    needToLineBreak: false,
    advantages: [
      "Реализация своих проектов не только в профессиональной сфере, но и в области нерабочих интересов и хобби",
      "Возможность собрать команду под свой проект внутри компании",
      "Поощрение инициатив",
    ],
    image: Achievement,
  },
  {
    title: "Комфортные условия",
    needToLineBreak: false,
    advantages: [
      "современные пространства для работы",
      "пространства для отдыха: кухни с бытовой техникой, кофейни, зоны релакса",
      "кинотеатр на работе, организованные премьерные кинопоказы",
      "программа привилегий для сотрудников: кафе, спортивные клубы, салоны красоты, онлайн-школы и так далее",
    ],
    image: Comfort,
  },
  {
    title: `Яркий \nотдых`,
    needToLineBreak: true,
    advantages: [
      "Корпоративные скидки на услуги Компании",
      "Спортивные и кибертурниры",
      "Корпоративные походы и развлечения",
    ],
    image: Relax,
  },
];

function PromotionCard(props) {
  const {
    title,
    advantages,
    image,
    needToLineBreak,
  } = props;

  const [isListShowed, toggleList] = useState(false);

  // const articleClickHandler = () => toggleList(!isListShowed);

  return (
    <article
      className="PromotionCard"
      style={{ backgroundImage: `url(${image})` }}
    >
      <h6 className="PromotionCard-title">
        { needToLineBreak ? <div style={{ whiteSpace: "pre-wrap" }}>{title}</div> : title }
      </h6>
      {isListShowed && (
        <motion.div
          className="PromotionCard-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 1000 } }}
        >
          <p className="PromotionCard-list-title">{title}</p>
          <ul className="PromotionCard-list">
            {advantages.map((el, i) => {
              return (
                <li
                  className="PromotionCard-list__item"
                  key={`promotion-card-${title}-${i}`}
                >
                  {el}
                </li>
              );
            })}
          </ul>
        </motion.div>
      )}
    </article>
  );
}

function PromotionCards(props) {
  const { title = "Работа у нас - это:" } = props;

  return (
    <section className="PromotionCards">
      <div className="PromotionCards-container">
        <h2 className="PromotionCards-title">{title}</h2>
        {mock.map((el, i) => {
          return (
            <PromotionCard
              key={`promotion-card-${el.title}-${i}`}
              title={el.title}
              advantages={el.advantages}
              needToLineBreak={el.needToLineBreak}
              image={el.image}
            />
          );
        })}
      </div>
    </section>
  );
}

export default PromotionCards;



// WEBPACK FOOTER //
// ./src/components/PromotionCards/index.js